import { useContext, useEffect, useState } from "react";
import { useMutation } from "react-query";
import { createJobProcess } from "@/api/query/jobProcess";
import { findAllLanguages } from "@/api/query/language";
import { MessageContext } from "@/common/contexts/message.context";
import {
  buildClearCsvImportedDataJob,
  getJobErrorMessage,
  mapLanguagesToOptions,
} from "../helpers";

const useClearCsvImportedData = ({ setClose, reloadMutation }) => {
  const [languagesOptions, setLanguagesOptions] = useState([]);
  const [selectedLanguage, setSelectedLanguage] = useState();

  const { addMessage } = useContext(MessageContext);

  const loadLanguagesMutation = useMutation({
    mutationFn: () => findAllLanguages(),
    onSuccess: ({ data }) => {
      setLanguagesOptions(mapLanguagesToOptions(data));
    },
  });

  const createJobProcessMutation = useMutation({
    mutationFn: (values) => createJobProcess(values),
    onSuccess: () => {
      addMessage("Added job", "success");
      setClose((prev) => !prev);
      reloadMutation.mutate();
    },
    onError: (error) => {
      addMessage(getJobErrorMessage(error), "error");
    },
  });

  const handleCreateJobProcess = () => {
    if (!selectedLanguage?.value) {
      addMessage("Select language", "error");
      return;
    }

    createJobProcessMutation.mutate(
      buildClearCsvImportedDataJob(selectedLanguage.value.shortName)
    );
  };

  useEffect(() => {
    loadLanguagesMutation.mutate();
  }, []);

  return {
    languagesOptions,
    selectedLanguage,
    setSelectedLanguage,
    isLoading: createJobProcessMutation.isLoading,
    handleCreateJobProcess,
  };
};

export default useClearCsvImportedData;
